<template>
  <v-container>
    <v-toolbar color="white" dark flat dense cad>
      <v-toolbar-title class="indigo--text">Datos de proveedor</v-toolbar-title>
    </v-toolbar>
    <v-form v-model="valid">
      <v-container>
        <v-layout>
          <v-flex>
            <!-- INICIO DATOS DE PROVEEDOR -->
            <contrato-edit
              :contrato="contrato"
              :tipeView="tipeView"
              @fecha-fin-actualizada="actualizarFechaFin" 
            ></contrato-edit>
            <!-- TERMINO DATOS DE PROVEEDOR -->
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Contactos proveedor</v-toolbar-title
              >
            </v-toolbar>
            <!-- CONTACTO PROVEEDOR -->
            <grid-contacto
              :key="proveedorContactoGrid"
              :tipoContacto="'PROVEEDOR'"
              :fechaFin="fechaFinContrato"
            ></grid-contacto>
            <v-spacer></v-spacer>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Contactos agencia</v-toolbar-title
              >
            </v-toolbar>
            <!-- CONTACTO AGENCIA -->
            <grid-contacto
              :key="agenciaContactoGrid"
              :tipoContacto="'AGENCIA'"
              :fechaFin="fechaFinContrato"
            ></grid-contacto>
            <!-- USUARIOS -->
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Usuarios proveedor</v-toolbar-title
              >
            </v-toolbar>
            <v-spacer></v-spacer>
            <grid-usuario
              :key="proveedorUsuarioGrid"
              :tipoUsuario="'PROVEEDOR'"
              :fechaFin="fechaFinContrato"
            ></grid-usuario>
            <v-spacer></v-spacer>
            <!-- PROVEEDOR -->
            <v-toolbar
              v-if="gridHidden != true"
              color="white"
              dark
              flat
              dense
              cad
            >
              <v-toolbar-title class="indigo--text"
                >Usuarios agencia</v-toolbar-title
              >
            </v-toolbar>
            <v-spacer></v-spacer>
            <grid-usuario
              v-if="gridHidden != true"
              :key="agenciaUsuarioGrid"
              :tipoUsuario="'AGENCIA'"
              :fechaFin="fechaFinContrato"
            ></grid-usuario>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import GridContacto from "@/modules/configuration/contacto/views/GridContacto.vue";
import GridUsuario from "@/modules/configuration/usuario/views/GridUsuario.vue";
import ContratoEdit from "@/modules/configuration/contrato/ContratoEdit.vue";

export default {
  components: {
    ContratoEdit,
    GridContacto,
    GridUsuario,
  },
  mixins: [validationMixin],
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    tabSelected: "",
  },
  data() {
    return {
      fechaFinContrato: null,
      gridHidden: false,
      contratoId: "",
      proveedorUsuarioGrid: 0,
      agenciaUsuarioGrid: 10,
      proveedorContactoGrid: 20,
      agenciaContactoGrid: 30,
      allowSpaces: false,
      valid: false,
      contactosAgenc: [],
      contactosProv: [],
      usuariosAgenc: [],
      usuariosProv: [],
      razonSocial: "",
      rut: "",
      direccion: "",
      regiones: "",
      comunas: "",
      nombre: "",
      regionesSelect: [],
      comunasSelect: [],
      contrato: [],
      loading: true,
      tipoUsuario: "",
    };
  },
  validations: {
    rut: { required, maxLength: maxLength(10) },
    regiones: { required },
    razonSocial: { required },
    direccion: { required },
    comunas: { required },
    nombre: { required },
  },
  computed: {},

  mounted() {},
  created() {
    //IGUAL ACA NO SE USA
    this.userlogged = this.$store.getters.userLogged.tipo;
    if (this.userlogged == "PROVEEDOR") {
      this.gridHidden = true;
    } else {
      this.gridHidden = false;
    }

    if (
      this.contratoId != null &&
      this.contratoId != "" &&
      this.contratoId !== undefined
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    }
  },
  methods: {
    actualizarFechaFin(nuevaFecha) {
      console.log("Fecha actualizada:", nuevaFecha);
    this.fechaFinContrato = nuevaFecha; // Actualiza la fecha
  },
    reloadAgenciaContact() {
      this.agenciaContactoGrid += 1;
    },
    reloadProveedorContact() {
      this.proveedorContactoGrid += 10;
    },
    reloadAgenciaUser() {
      this.agenciaUsuarioGrid += 20;
    },
    reloadProveedorUser() {
      this.proveedorUsuarioGrid += 30;
    },
  },
};
</script>
